import React from "react";
import { Navigate } from "react-router-dom";
import { useApp } from "../context/AppContext";

export default function ProtectedRoute({ children }) {
  const { user, loading } = useApp();
  if (loading) return <div className="min-h-screen flex items-center justify-center text-white/40 font-serif text-lg">Loading…</div>;
  if (!user) return <Navigate to="/login" replace/>;
  return children;
}
